import { useState } from "react";
import { motion } from "framer-motion";
import { CheckCircle2, CreditCard } from "lucide-react";
import PayPalCheckout from "@/components/PayPalCheckout";

export default function BookingConfirmation({ confirmed, payments, payer }) {
  const [depositOpen, setDepositOpen] = useState(false);

  return (
    <section id="booking" data-testid="booking-section" className="border-t border-linen bg-forest">
      <div className="mx-auto max-w-7xl px-6 py-28 md:px-10 md:py-36">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
          className="mx-auto max-w-2xl text-center"
          data-testid="booking-confirmation"
        >
          <CheckCircle2 size={48} className="mx-auto mb-8 text-bone" />
          <p className="mb-6 font-mono text-[11px] uppercase tracking-[0.35em] text-bone/60">Consultation Confirmed</p>
          <h2 className="mb-6 font-serif text-4xl font-medium leading-tight text-bone md:text-5xl" data-testid="booking-confirmation-heading">
            See you <span className="italic">soon</span>.
          </h2>
          <p className="mb-4 font-mono text-sm tracking-wide text-bone/80" data-testid="booking-confirmation-details">
            {confirmed.pretty}
          </p>
          <p className="text-sm leading-relaxed text-bone/60">
            A confirmation email with your date and time is on its way to your inbox. Zecharias
            will reach out with meeting details before your session. Need to change it? Email{" "}
            <a href="mailto:Info@bookcarellc.com" className="underline underline-offset-4">Info@bookcarellc.com</a>.
          </p>

          {payments?.configured && (
            <div className="mt-12 border border-bone/20 bg-bone/5 p-8 text-left" data-testid="booking-deposit-card">
              <p className="mb-3 font-mono text-[10px] uppercase tracking-[0.25em] text-bone/50">Optional — hold your slot</p>
              <p className="mb-5 text-sm leading-relaxed text-bone/70">
                Want your time locked in? Place a fully refundable <strong className="text-bone">$50 deposit</strong>.
                It is credited to your first invoice, or refunded in full if you cancel.
              </p>
              <button
                type="button"
                onClick={() => setDepositOpen(true)}
                data-testid="booking-deposit-button"
                className="inline-flex items-center gap-2 border border-bone px-6 py-3.5 font-mono text-[11px] uppercase tracking-[0.2em] text-bone transition-colors duration-300 hover:bg-bone hover:text-forest"
              >
                <CreditCard size={14} /> Pay $50 deposit
              </button>
            </div>
          )}

          {depositOpen && (
            <PayPalCheckout
              packageId="consult_deposit"
              label="Consultation hold — refundable deposit"
              price="$50.00"
              note={`Holds your ${confirmed.pretty} consultation. Credited to your first invoice or refunded in full.`}
              payer={payer}
              bookingId={confirmed.id}
              config={payments}
              onClose={() => setDepositOpen(false)}
            />
          )}
        </motion.div>
      </div>
    </section>
  );
}
